import { ref } from 'vue';
import { reactive } from 'vue'; // Use reactive for the snackbar object

// Create reactive state outside the composable function
// This ensures the state is shared across all components using the composable
const snackbarState = reactive({
    show: false,
    message: '',
    color: 'success',
    timeout: 3000,
    location: 'top right', // Default location
    // Optional { label, onClick } rendered as an extra button (e.g. "Tentar novamente").
    action: null,
});

export function useSnackbar() {

    const showSnackbar = (message, color = 'success', timeout = 3000, location, action = null) => {
        snackbarState.message = message;
        snackbarState.color = color;
        snackbarState.timeout = timeout;
        snackbarState.location = location || 'top right'; // Use provided location or default
        snackbarState.action = action;
        snackbarState.show = true; // Trigger reactivity
    };

    const hideSnackbar = () => {
        snackbarState.show = false;
    };

    const runSnackbarAction = () => {
        const action = snackbarState.action;
        snackbarState.show = false;
        action?.onClick();
    };

    // Return the reactive state and the functions
    // Use toRefs if you need to destructure the state in the component template
    // but usually accessing via snackbarState.show etc. is fine.
    return {
        snackbarState,
        showSnackbar,
        hideSnackbar,
        runSnackbarAction,
    };
}
